import { apiFetch } from './api';

/**
 * Journal des emails envoyés (migration 089) : chaque envoi réel y laisse
 * son objet, son corps, son destinataire et ses pièces jointes. Les onglets
 * « Emails » des fiches le lisent avec le filtre de leur dossier.
 */
export function getEmailsEnvoyes(params = {}) {
  const query = new URLSearchParams();
  for (const [cle, valeur] of Object.entries(params)) {
    if (valeur !== undefined && valeur !== null && valeur !== '') query.set(cle, valeur);
  }
  const s = query.toString();
  return apiFetch(`/emails-envoyes${s ? `?${s}` : ''}`);
}
